module.exports = __webpack_public_path__ + "static/media/dronesActive.3e0eaa7e.png";